import { render, staticRenderFns } from "./getGoodsPicking.vue?vue&type=template&id=3bf2d302&scoped=true&"
import script from "./getGoodsPicking.vue?vue&type=script&lang=js&"
export * from "./getGoodsPicking.vue?vue&type=script&lang=js&"
import style0 from "./getGoodsPicking.vue?vue&type=style&index=0&id=3bf2d302&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2d302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf2d302')) {
      api.createRecord('3bf2d302', component.options)
    } else {
      api.reload('3bf2d302', component.options)
    }
    module.hot.accept("./getGoodsPicking.vue?vue&type=template&id=3bf2d302&scoped=true&", function () {
      api.rerender('3bf2d302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/temporaryTemplate/goodsPicking/getGoodsPicking.vue"
export default component.exports